/**
 * 👥 직원 명부 API (v2.325.0) — backend /admin/staff (관리자 + 경영지원 지정 · lib/staff-directory.ts).
 *   직원 정보 칸(이름·직급·부서·팀·휴대폰)만 고친다 — 계정 권한(역할·비밀번호·이메일·로그인)은 admin-api 의 /admin/users.
 */
import { api } from './api';

export interface StaffRow {
  userId: string;
  name: string | null;
  title: string | null;
  department: string | null;
  team: string | null;
  mobile: string | null;
  /** 웍스 주소 — 보기만(비밀번호 찾기 메일이 가는 곳이라 관리자만 고친다) */
  email: string | null;
  /** 로그인 켜짐 — 보기만(퇴사자 로그인 막기는 관리자) */
  loginActive: boolean;
}

export interface StaffList {
  rows: StaffRow[];
  /** 고를 수 있는 부서 — 지금 직원들에게 적힌 부서들(새 부서는 관리자가 계정 관리에서) */
  departments: string[];
}

/** 보낸 칸만 바꾼다 — 빈 글자는 서버가 비움(null)으로 */
export interface StaffUpdateInput {
  name?: string;
  title?: string | null;
  department?: string | null;
  team?: string | null;
  mobile?: string | null;
}

export function listStaff(): Promise<StaffList> {
  return api.get('/admin/staff');
}

export function updateStaff(userId: string, input: StaffUpdateInput): Promise<{ userId: string }> {
  return api.patch(`/admin/staff/${encodeURIComponent(userId)}`, input);
}
